import { useTheme, Text, Grid } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';

import Tooltip from '@/components/Tooltip';

export const FairValueTooltip = () => {
  const theme = useTheme();
  return (
    <Tooltip
      title={
        <Grid rowGap="8px" maxWidth="250px" paddingY="x1" paddingX="x1_5">
          <Text typography="tiny" color="spaceGray">
            Fair value is the current intrinsic value of a company based on an
            estimate of its potential future profits (analyst consensus
            forecasts).
          </Text>
          <Text typography="tiny" color="spaceGray">
            The discount is the difference between the current price and its
            estimated fair value.
          </Text>
          <Text typography="tiny" color="spaceGray">
            Learn more about valuation on our Help Centre
          </Text>
        </Grid>
      }
      light
      placement="top"
      zIndex={99999}
    >
      <Grid cursor="help">
        <InformationSolid fill={theme.color.whiteRGBA(0.5)} />
      </Grid>
    </Tooltip>
  );
};
